<template>
  <span></span>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  computed: {
    submitUri() {
      return `bot/create`
    },
    data() {
      return {
        platform: 'telegram'
      }
    }
  },
  created() {
    this.submit()
  },
  methods: {
    submit() {
      this.submitForm(this.data, {
        done: (response) => {
          if (!_.isUndefined(response.id)) {
            this.$emitter.emit('Modal', {
              name: 'bot.edit',
              data: {
                _id: response.id,
                _platform: this.platform
              },
              $el: this.$el
            })
          }
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
